
const t = require('engine/i18n/t');
const LANG = require('config').lang;

t.i18n.add('courses', require('../../locales/' + LANG + '.yml'));

module.exports = class ParticipantsCounter {
  constructor(options) {
    this.elem = options.elem;

    this.elems = {};
    [].forEach.call(this.elem.querySelectorAll('[data-elem]'), (el) => {
      this.elems[el.getAttribute('data-elem')] = el;
    });

    this._count = +this.elems.participantsCountInput.value;

    if (this.elems.participantsIncreaseButton) {
      // when only 1 place in group, no buttons
      this.elems.participantsDecreaseButton.onclick = e => this.onParticipantsDecreaseButtonClick(e);
      this.elems.participantsDecreaseButton.onmousedown = () => false;
      this.elems.participantsIncreaseButton.onclick = e => this.onParticipantsIncreaseButtonClick(e);
      this.elems.participantsIncreaseButton.onmousedown = () => false;
    }

    this.elems.participantsCountInput.onkeydown = (e) => {
      // Enter does not submit the form
      if (e.keyCode == 13 && e.target.tagName == 'INPUT') {
        e.preventDefault();
        e.target.blur();
      }
    };

    this.elems.participantsCountInput.oninput = event => this.onParticipantsCountInputChange(event);
  }

  onParticipantsDecreaseButtonClick(event) {
    this.setCount(this.elems.participantsCountInput.value - 1);
  }

  onParticipantsIncreaseButtonClick(event) {
    this.setCount(+this.elems.participantsCountInput.value + 1);
  }

  onParticipantsCountInputChange(event) {
    this.setCount(this.elems.participantsCountInput.value);
  }

  isValid() {
    return this.elems.participantsCountInput.parentNode.classList.contains('text-input_invalid');
  }

  setCount(count) {
    count = parseInt(count, 10) || 0;

    this.elems.participantsCountInput.value = count;

    let max = +this.elems.participantsCountInput.getAttribute('max');

    if (this.elems.participantsDecreaseButton) {
      this.elems.participantsDecreaseButton.disabled = (count <= 1);
      this.elems.participantsIncreaseButton.disabled = (count >= max);
    }

    let invalid = count < 1 || count > max;
    if (invalid) {
      this.elems.participantsCountInput.parentNode.classList.add('text-input_invalid');
      return;
    }

    this.elems.participantsCountInput.parentNode.classList.remove('text-input_invalid');

    let isCountUpdated = count != this._count;
    this._count = count;

    if (!isCountUpdated) return;

    this.elem.dispatchEvent(new CustomEvent('change-count', {
      detail: {
        count: count
      }
    }));

  }

  getCount() {
    return this._count;
  }
};
